import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import baseURL from '../../Config';
import { Button } from 'primereact/button';

export default function CallAudio({ callId, language }) {
    const t = (en, es) => language === 'es' ? es : en;
    const [url, setUrl] = useState('');
    const [state, setState] = useState('idle');
    const request = useRef(0);
    useEffect(() => { setUrl(''); setState('idle'); return () => { request.current++; }; }, [callId]);
    const load = async () => {
        const sequence = ++request.current;
        setUrl(''); setState('loading');
        try {
            const login = JSON.parse(localStorage.getItem('adminUser') || localStorage.getItem('userDetails') || '{}');
            const token = login?.data?.token || login?.data?.accessToken;
            const result = await axios.get(`${baseURL}vapi/calls/${encodeURIComponent(callId)}/audio`, { headers: { authorization: `Bearer ${token}` }, timeout: 35000 });
            if (sequence !== request.current) return;
            if (!result.data?.url) throw new Error('Missing playback URL');
            setUrl(result.data.url); setState('ready');
        } catch (error) {
            if (sequence === request.current) setState(error.response?.status === 404 ? 'missing' : 'error');
        }
    };
    return <section>
        <h3>{t('Call audio', 'Audio de la llamada')}</h3>
        {url && <audio key={url} aria-label={t('Call recording', 'Grabación de la llamada')} controls preload="metadata" src={url} style={{ width: '100%' }} onError={() => { setUrl(''); setState('error'); }} />}
        {state === 'missing' && <p>{t('No recording is available for this call.', 'No hay una grabación disponible para esta llamada.')}</p>}
        {state === 'error' && <p role="alert">{t('Audio could not be loaded. Retry to get a fresh playback link.', 'No se pudo cargar el audio. Reintente para obtener un enlace nuevo.')}</p>}
        {!url && <Button label={state === 'idle' ? t('Load audio', 'Cargar audio') : state === 'loading' ? t('Loading…', 'Cargando…') : t('Retry', 'Reintentar')} icon="pi pi-volume-up" className="p-button-outlined" disabled={state === 'loading'} onClick={load} />}
    </section>;
}
